//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'm-buy',
  data () {
    return {
      isSaas: false
    }
  },
  props: [
    'measureState',
    'isShow'
  ],
  mounted () {
    this.auth
  },
  computed: {
    h5 () {
      return this.$store.state.app.h5
    },
    inJihuashuProducts () {
      if (['150476691002746473', '150537492578996275', '150570517523511386', '150546537968917914'].indexOf(this.$store.state.app.productCode) === -1) {
        return false
      }
      return true
    },
    tel () {
      if (this.$store.state.config.serviceTel) {
        return this.$store.state.config.serviceTel
      }
      return '400-661-2992'
    },
    online () {
      console.log(this.$route.query.saas)
      let productCode = this.$route.params.productCode
      let merchantCode = this.$route.params.innerCode
      let online = ''
      this.$http.post('/api/cms/productInfo/' + productCode + '?merchantCode=' + merchantCode).then((response) => {
        online = `https://webchat.7moor.com/wapchat.html?accessId=830c0a20-96ed-11e8-900e-615f5f8f9cf2&fromUrl=&urlTitle=&otherParams={"nickName":"${response.data.busMerchant.merchantName}"}`
        window.jQuery('#online-ask-about').attr('href', online)
      })
    },
    yyfw () {
      let productCode = this.$route.params.productCode
      let merchantCode = this.$route.params.innerCode
      return '/products/' + productCode + '/reserv?merchantCode=' + merchantCode + '&utmSource=h5&source=1'
    },
    auth () {
      let hostName = window.location.hostname
      let base = ''
      let merchantCode = this.$route.params.innerCode
      console.log(merchantCode)
      if (hostName === 'test1.m.wkbins.com' || hostName === 'test.m.wkbins.com') {
        base = '//test.merchant.wkbins.com'
      } else if (hostName === 'm.wkbins.com') {
        base = '//wkbyf.wkbins.com'
      }
      window.jQuery('#tel-ask-about').attr('href', 'tel:3333333')
      console.log(base + '/saasSystem/reservationSettinger?merchantCode=' + merchantCode + '&callback=?')
      window.jQuery.getJSON(base + '/api2/saasSystem/reservationSettinger?merchantCode=' + merchantCode + '&callback=?', function (data) {
        console.log(data)
        window.jQuery('#online-ask-about').hide()
        window.jQuery('#reserv-service-about').hide()
        if (data.customerEntrance === 1) {
          window.jQuery('#online-ask-about').show()
        }
        if (data.appointmentAdvisor === 1) {
          window.jQuery('#reserv-service-about').show()
        }
        window.jQuery('#tel-ask-about').attr('href', 'tel:' + data.serviceTel)
        console.log(window.jQuery('#tel-ask-about').attr('href'))
      })

      if (this.$route.query.saas && this.$route.query.saas === '1') {
        window.jQuery('.btn').hide()
      }
    },
    buyName () {
      if (this.$store.state.config.buyName) return this.$store.state.config.buyName
      return '立即购买'
    },
    number () {
      if (!this.measureState) {
        return this.$store.state.config.minPremium
      } else if (this.measureState) {
        if (this.$store.state.measure.success === '') {
          /**
           * 年交和月交
           * 最小额度不同
           */
          if (this.$store.state.config.form && this.$store.state.config.form.paymentModes) {
            const length = this.$store.state.config.form.paymentModes.list.length
            for (let i = 0; i < length; i++) {
              if (this.$store.state.config.form.paymentModes.list[i].value === this.$store.state.order.paymentMode) {
                return this.$store.state.config.form.paymentModes.list[i].minPremium
              }
            }
          }
          return this.$store.state.config.minPremium
        }
        return this.$store.state.measure.basePremium * this.$store.state.order.coverage / 100
      }
    },
    paymentUnit () {
      if (!this.measureState) {
        return '年'
      }
      if (this.$store.state.order.paymentMode === 1) {
        return '年'
      }
      if (this.$store.state.order.paymentMode === 2) {
        return '月'
      }
      return this.$store.state.config.paymentUnit
    },
    measureSuccess () {
      return this.$store.state.measure.success
    },
    phoneIcon () {
      if (this.$store.state.config.phoneIcon) {
        return this.$store.state.config.phoneIcon
      }
    },
    posterIcon () {
      if (this.$store.state.config.posterIcon) {
        return this.$store.state.config.posterIcon
      }
    },
    jihuashuIcon () {
      if (this.$store.state.config.jihuashuIcon) {
        return this.$store.state.config.jihuashuIcon
      }
    },
    showPoster () {
      /**
       * 判断是否显示海报
       */
      // 是否是分享过的
      const isShare = this.$route.query.isShare
      // 是否是悟空保的innerCode
      const isWKB = ['149673178664394306', '148198068433580000'].indexOf(this.$store.state.app.innerCode) !== -1
      // 代理人是否有资质认证
      const haveQulification = this.$route.query.haveQulification
      if ((isShare === 'true') || isWKB || this.h5 || haveQulification !== '1') return false
      return true
    },
    isDailiren () {
      // 是合伙人
      // 不是悟空保，且不是H5
      // 是否是悟空保的innerCode
      const isWKB = ['149673178664394306', '148198068433580000'].indexOf(this.$store.state.app.innerCode) !== -1
      if (!this.h5 && !isWKB) {
        return true
      }
      return false
    },
    isProspectus () {
      const isProspectus = this.$route.query.isProspectus
      if (isProspectus !== undefined) return true
      return false
    },
    posterURL () {
      return window.location.protocol + '//' + window.location.hostname + '/illness/sharePoster?productCode=' + this.$store.state.app.productCode + '&innerCode=' + this.$store.state.app.innerCode
    },
    jihuashuURL () {
      return window.location.protocol + '//' + window.location.hostname + '/prospectus/index?productCode=' + this.$store.state.app.productCode
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Buy.vue